import { render } from "./CardCoupons.vue?vue&type=template&id=3ecec4c4&scoped=true"
import script from "./CardCoupons.vue?vue&type=script&lang=js"
export * from "./CardCoupons.vue?vue&type=script&lang=js"

import "./CardCoupons.vue?vue&type=style&index=0&id=3ecec4c4&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ecec4c4"]])

export default __exports__